import { formatNumber } from '@progress/kendo-intl'

import { addPtsUnit } from './internal/addPtsUnit'

/**
 * 総数に対する集計数の比率をフォーマットします。
 *
 * @param ratio - 総数に対する集計数の比率。
 * @returns "pts"単位付き文字列と単位なし文字列。
 */
export function ratioToPts(
  ratio: number,
): [ptsText: string, nonUnitText: string] {
  const nonUnitText = formatNumber(ratio * 100, 'n1')
  const ptsText = addPtsUnit(nonUnitText)

  return [ptsText, nonUnitText]
}
